import React, { useState } from "react";
import "./index.scss";
import { postRequest } from "../../../../services/requestService";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import { useLocation } from "react-router-dom";
import BeautifulLoader from "../../../../components/layout/BeautifulLoader";
import { Spin } from "antd";
import { BASE_URL, setCookie } from "../../../../services/clientService";
import { reportEvent } from "../../../../services/analyticsService";
import Dragger from "antd/es/upload/Dragger";
import { CgFileDocument } from '@react-icons/all-files/cg/CgFileDocument';
import CreateLoader from "../CreateLoader";

const IntroStep = (props) => {
    const [loading, setLoading] = useState(false)
    const [showUpload, setShowUpload] = useState(false)
    const [success, setSuccess] = useState(false)
    const [option, setOption] = useState();
    const dispatch = useDispatch()
    const location = useLocation()
    
    const onCreateResume = async () => {
        reportEvent('resume_builder', 'create_click', { kind: 'scratch' })
        setLoading(true)
        console.log('Creating resume...')
        const res = await postRequest('resume/create')
        console.log('Resume created:', res.data.resume._id)
        setTimeout(() => {
            console.log('Navigating to resume builder with personal step')
            dispatch(push(`/resume-builder/${res.data.resume._id}/personal`, { from: location.pathname }))
            setCookie('resume_id', res.data.resume._id)
            reportEvent('resume_builder', 'create_success', { kind: 'scratch' })
            props.setResume(res.data.resume)
        }, 1000)
    }
    const onResumeFileSelect = async data => {
        setLoading(true)
        reportEvent('resume_builder', 'create_click', { kind: 'file_upload' })
        const { file } = data;
        console.log(data)
        if (file.status !== 'done') return;
        if (!file?.response?.resume) return;
        setLoading(false)
        const { resume } = file.response;
        setSuccess(true)
        reportEvent('resume_builder', 'create_success', { kind: 'file_upload' })
        setCookie('resume_id', resume._id)
        props.setResume(resume)
        dispatch(push(`/resume-builder/${resume._id}/personal`, { from: location.pathname }))
    }

    return (
        <div className="intro-step-container">
            {loading && <CreateLoader success={success} option={option}  />}
            <img src="/logos/logo-genie-blue.png" alt="Genie Logo" className="intro-step-logo" />
            <>
                <h1 className="intro-step-title">How will you make<br />your resume?</h1>
                <div className="intro-step-options">
                    <div className="intro-step-option" onClick={onCreateResume}>
                        <div className="intro-step-icon intro-step-icon--sparkle">
                            {/* Sparkle icon */}
                            <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="14" fill="#2563eb" /><path d="M14 7v6m0 0v6m0-6h6m-6 0H8" stroke="#fff" strokeWidth="2" strokeLinecap="round" /></svg>
                        </div>
                        <div className="intro-step-content">
                            <div className="intro-step-option-title">Start from scratch</div>
                            <div className="intro-step-option-subtitle">Our AI helper will guide you</div>
                        </div>
                        <div className="intro-step-arrow">
                            <svg width="24" height="24" fill="none"><path d="M9 6l6 6-6 6" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </div>
                    </div>
                    <div className={`intro-step-option ${showUpload ? 'active' : ''}`} style={{ flexDirection: 'column', alignItems: 'stretch' }}>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div className="intro-step-icon intro-step-icon--doc">
                                {/* Document icon */}
                                <svg width="28" height="28" viewBox="0 0 28 28" fill="none"><circle cx="14" cy="14" r="14" fill="#2563eb" /><rect x="9" y="8" width="10" height="12" rx="2" fill="#fff" /><rect x="11" y="10" width="6" height="2" rx="1" fill="#2563eb" /><rect x="11" y="14" width="6" height="2" rx="1" fill="#2563eb" /></svg>
                            </div>
                            <div className="intro-step-content" onClick={() => setShowUpload(v => !v)}>
                                <div className="intro-step-option-title">I already have a resume</div>
                                <div className="intro-step-option-subtitle">Upload document</div>
                            </div>
                            <div className="intro-step-arrow" onClick={() => setShowUpload(v => !v)}>
                                <svg
                                    width="24"
                                    height="24"
                                    fill="none"
                                    style={{
                                        transition: 'transform 0.2s',
                                        transform: showUpload ? 'rotate(90deg)' : 'none'
                                    }}
                                >
                                    <path d="M9 6l6 6-6 6" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                            </div>
                        </div>
                        {showUpload && (
                            <div className="intro-step-upload-collapse" style={{ marginTop: 24 }}>
                                <Dragger loading={loading}
                                    action={`${BASE_URL}/RESUME/upload-guest`}
                                    onChange={onResumeFileSelect} multiple={false}
                                    showUploadList={false} style={{ background: 'white', borderRadius: 16, padding: 0 }}>
                                    <CgFileDocument className="icon" />
                                    <div className="title">Drag and drop your resume here</div>
                                    <div className="subtitle">or <span className="choose-file">choose the file</span> to upload</div>
                                </Dragger>
                            </div>
                        )}
                    </div>
                </div>
            </>
        </div>
    );
};

export default IntroStep;
